/* Shared navigation: native links, focus containment, Escape and reliable cleanup. */
(() => {
  'use strict';
  const key = '__patchistryExpressionNav';
  if (window[key]) { window[key].scan(); return; }
  let instance = null;
  function scan() {
    const drawer = document.getElementById('p-nav-drawer');
    const trigger = document.querySelector('[data-p-hamburger]');
    if (instance && instance.drawer === drawer) return;
    if (instance) instance.destroy();
    instance = null;
    if (!drawer || !trigger) return;
    const closeButton = drawer.querySelector('[data-p-drawer-close]');
    const overlay = drawer.querySelector('[data-p-drawer-overlay]');
    const cleanups = [];
    let opened = false, previousOverflow = '', restoreFocus = null;
    const inerted = [];
    const on = (el, type, fn, options) => {
      if (!el) return;
      el.addEventListener(type, fn, options);
      cleanups.push(() => el.removeEventListener(type, fn, options));
    };
    function focusables() {
      return [...drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length && !el.closest('[hidden],[inert]'));
    }
    function isolate() {
      let node = drawer;
      while (node.parentElement && node !== document.body) {
        for (const sibling of node.parentElement.children) {
          if (sibling === node || ['SCRIPT','STYLE','LINK'].includes(sibling.tagName) || sibling.inert) continue;
          sibling.inert = true; inerted.push(sibling);
        }
        node = node.parentElement;
      }
    }
    function close(returnFocus = true) {
      if (!opened) return;
      opened = false;
      drawer.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      inerted.splice(0).forEach(el => { el.inert = false; });
      document.body.style.overflow = previousOverflow;
      if (returnFocus && restoreFocus && restoreFocus.isConnected) restoreFocus.focus();
      drawer.inert = true;
      drawer.setAttribute('aria-hidden', 'true');
    }
    function open() {
      if (opened) return;
      opened = true; restoreFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      drawer.inert = false; drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeButton) closeButton.focus();
      isolate();
    }
    on(trigger, 'click', open);
    on(closeButton, 'click', () => close());
    on(overlay, 'click', () => close());
    on(drawer, 'click', e => {
      if (e.target.closest('a[href]')) close(false);
    });
    on(drawer.querySelector('[data-p-drawer-sage]'), 'click', () => {
      close();
      const sage = document.querySelector('.pp-conc-bubble') || document.getElementById('header-concierge-trigger');
      if (sage) sage.click();
    });
    on(document, 'keydown', e => {
      if (!opened) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const items = focusables();
      const first = items[0], last = items[items.length - 1];
      if (!first) { e.preventDefault(); return; }
      if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
    on(window, 'pagehide', () => close(false));
    instance = { drawer, destroy() { close(false); cleanups.forEach(fn => fn()); } };
  }
  window[key] = { scan };
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', e => {
    if (instance && e.target.contains(instance.drawer)) { instance.destroy(); instance = null; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
